<template>
<div class="container-fluid">
    <div v-if="!isCognito&&isMessage" class="alert alert-danger alert-margin" role="alert">
      {{ message }}
    </div>
    <div v-if="isCognito" class="login">
      <img class="logo" :src="require(`@/assets/${logo}.png`)" width="15%" height="15%">
      <div id="inputform" class="rounded border">
        <form class="login_form rounded" @submit.prevent="login">
          <div class="form-group">
            <label class="control-label">{{tenantLabel}}</label>
            <input type="text" :placeholder="[[ tenantLabel ]]" v-model="hospitalCode" required class="form-control">
          </div>
          <div class="form-group">
            <label class="control-label">ID</label>
            <input type="text" placeholder="ユーザーID" v-model="userCode" required class="form-control">
          </div>
          <div class="form-group">
            <label class="control-label">パスワード</label>
            <input type="password" placeholder="パスワード" v-model="password" required class="form-control">
          </div>
          <div class="alert alert-danger" role="alert" v-if="isMessage">
            {{ message }}
          </div>
          <button class="btn btn-info btn-block" v-bind:class="{ loginbtn: !isMessage }">ログイン</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import authority from '../authority'
import axios from "axios"
import { headers } from '../mixin/headers'

export default {
  name: 'LoginPage',
  src: {
    authority
  },
  mixins: [headers],
  props: ['realms','serviceName'],
  data () {
    return {
      hospitalCode: '',
      userCode: '',
      password: '',
      message: ''
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isCognito: function() {
      return this.$cognito.isUseCognito
    },
    tenantLabel: function (){
      return this.serviceName === 'SmartPhone' ? '事業所コード' : '病院コード'
    },
    logo: function (){
      if (this.serviceName === 'SmartPhone') {
        return "smart-logo"
      } else {
        return "logo"
      }
    }
  },
  beforeMount(){
      if(!this.$cognito.isUseCognito){
        if(this.realms === undefined){
          this.$router.push({name: 'notFoundPage'})
        }else if(!this.$store.state.auth.isLogIn){
          window.location.href = 
          this.$cognito.options.AuthUri
          + this.realms 
          + "/protocol/openid-connect/auth"
          + "?response_type=code&client_id=nichibyo-mobile&state=xyz&scope=openid&redirect_uri="
          + window.location.origin
          + "/"
          + this.realms
          + "/keycloak&nonce=abcd12345"
        }
      }
  },
  mounted() {
    if(this.$route.query.tenant){
      this.hospitalCode = this.$route.query.tenant;
    }
    if(this.$route.query.id){
      this.userCode = this.$route.query.id;
    }
    if(!this.$cognito.isUseCognito && this.$store.state.auth.isLogIn){
        var privilege = this.$store.state.auth.privilege
        if(privilege){
          if(authority.notLogin.indexOf(Number(privilege)) !== -1){
            this.message = "管理者権限がありません"
            // ログアウト処理
            this.$cognito.isAuthenticated().then((session) => {
              if(session){
                  var accessToken = session.accessToken
                  axios.post("/api/user/keycloak/logout/", {
                      hospitalCode: this.realms,
                      refreshToken: session.refreshToken
                  },{
                    headers: this.headers(accessToken)
                  }).then(() => {
                    // nothing to do
                  })
              }
            })
          }
        }
    }
  },
  methods: {
    login () {
      var username = this.userCode + '@' + this.hospitalCode;
      this.$cognito.login(username, this.password)
        .then((result) => {
          var idToken = result.getIdToken()
          var privilege = idToken.payload['custom:privilege']
          if(privilege !== undefined && authority.notLogin.indexOf(Number(privilege)) === -1){
            this.$router.replace('/common/user/index')
          } else {
            this.message = "管理者権限がありません"
            this.$cognito.logout()
          }         
        })
        .catch(error => {
          this.message = error.message
        })
    }
  }
}
</script>

<style scoped>
.login {
  text-align: center;
}
.logo {
  margin-top: 50px;
  margin-bottom: 40px;
}
.login_form {
  text-align:left;
  padding: 30px;
  background: #ffffff;  
}
#inputform {
  margin:0 auto;
  width: 40%;
}
.loginbtn {
  margin-top: 30px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 0.5rem;
}
</style>
